import { Container, Stack } from '@mui/material';
import React, { useEffect } from 'react';
import Notifications from '../components/Admin/Notifications';
import NotificationsProvider from '../lib/contexts/NotificationsContext';
import useTrackPageView from '../lib/hooks/use-track-page-view';

const AdminPage = () => {
    const trackPageView = useTrackPageView();

    useEffect(() => {
        trackPageView('Admin page');
    }, [trackPageView]);
    return (
        <Container maxWidth={'xl'} sx={{ marginBottom: 2 }}>
            <Stack>
                <NotificationsProvider>
                    <Notifications />
                </NotificationsProvider>
            </Stack>
        </Container>
    );
};

export default AdminPage;
